import { render, staticRenderFns } from "./block-organization-acts.vue?vue&type=template&id=4b6dae0d&scoped=true&lang=pug"
import script from "./block-organization-acts.vue?vue&type=script&lang=js"
export * from "./block-organization-acts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6dae0d",
  null
  
)

export default component.exports